import React from "react";
import {
  Modal,
  Input,
  Box,
  SpaceBetween,
  Button,
  FormField,
} from "@amzn/awsui-components-react";

interface FolderManagementModalProps {
  visible: boolean;
  onDismiss: () => void;
  onSave: () => void;
  folderName: string;
  setFolderName: (name: string) => void;
  isEditing: boolean;
  error: string;
}

export function FolderManagement({
  visible,
  onDismiss,
  onSave,
  folderName,
  setFolderName,
  isEditing,
  error,
}: FolderManagementModalProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={isEditing ? "Edit Folder Name" : "Create New Folder"}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSave}>
              {isEditing ? "Save Changes" : "Create"}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <FormField label="Folder name" errorText={error}>
        <Input
          value={folderName}
          onChange={({ detail }) => {
            setFolderName(detail.value);
          }}
          placeholder="Enter folder name"
          autoFocus
        />
      </FormField>
    </Modal>
  );
}
